import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
// import { useAirlineServices,useAirportConsultancy,useCommercialLeasing } from "../BusinessOppurtunities/BusinessOppurtunities.hook";
import { post, put } from "~/Services";
import SmallCards from "./SmallCards/SmallCards";
import LargeCards from "./LargeCards/LargeCards";
import { fields } from "../../MediaCentre/constants";
const SpotLight = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

//   const { data: airlineServicesData, isLoading: isLoadingAirlineServices } = useAirlineServices();
//   const { data: airportConsultancyData, isLoading: isLoadingAirportConsultancy } = useAirportConsultancy();
//   const { data: commercialLeasingData, isLoading: isLoadingCommercialLeasing } = useCommercialLeasing();

  useEffect(() => {
    if (!query.get("activeTab")) {
      if (hasRole(["SUPER_ADMIN"])) {
        navigate(`/dedicated/corporate/business-oppurtunities?activeTab=airlineServices`, {
          replace: true,
        });
      }
    }
  }, []);

//   const AirlineServicesConfig: FormConfig = {
//     initialValues: {},
//     fields: fields.airlineServices,
//   };

//   const AirportConsultancyConfig: FormConfig = {
//     initialValues: {
//       field_content_english_markup: airportConsultancyData?.[0]?.field_content_english?.data?.markup,
//       field_content_english_next_page_name: airportConsultancyData?.[0]?.field_content_english?.data?.nextPage?.name,
//       field_content_english_next_page_link: airportConsultancyData?.[0]?.field_content_english?.data?.nextPage?.link,
//       field_content_ms_markup: airportConsultancyData?.[0]?.field_content_malay?.data?.markup,
//       field_content_ms_next_page_name: airportConsultancyData?.[0]?.field_content_malay?.data?.nextPage?.name,
//       field_content_ms_next_page_link: airportConsultancyData?.[0]?.field_content_malay?.data?.nextPage?.link,
//       field_content_zh_markup: airportConsultancyData?.[0]?.field_content_mandarin?.data?.markup,
//       field_content_zh_next_page_name: airportConsultancyData?.[0]?.field_content_mandarin?.data?.nextPage?.name,
//       field_content_zh_next_page_link: airportConsultancyData?.[0]?.field_content_mandarin?.data?.nextPage?.link,
//     },
//     fields: fields.airportConsultancy,
//   };

//   const CommercialLeasingConfig: FormConfig = {
//     initialValues: {},
//     fields: fields.airlineServices,
//   };

//   const onSubmit = async (
//     data: FieldValues,
//     apiUrl: string,
//     action: string,
//     method: string,
//     status: "DRAFT" | "PENDING"
//   ) => {
//     const payload = {
//       action: action,
//       method: method,
//       module: "Business-oppurtunities",
//       subModule: query?.get("activeTab"),
//       type: "DEDICATED",
//       application: "MAHB_CORPORATE",
//       appList: [
//         {
//           appName: "CORPORATE",
//           apiUrl: apiUrl,
//         },
//       ],
//       payload: {
//         id: data?.id,
//         ...data,
//         published: true,
//         createdAt: "2024-07-16T07:44:25",
//         updatedAt: "2024-07-16T07:44:30",
//       },
//       status: status,
//     };

//     console.log("payload", payload.payload);
//     if (query.get("id")) {
//       put(`/management/update-document?approvalId=${query.get("id")}`, payload)
//         .then((response) => {
//           openToast({
//             content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
//             type: "success",
//           });
//         })
//         .catch((err: any) => {
//           openToast({
//             content: "Failed to save data",
//             type: "error",
//           });
//         });
//     } else {
//       post("/management/publish", payload)
//         .then((response) => {
//           openToast({
//             content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
//             type: "success",
//           });
//         })
//         .catch((err: any) => {
//           openToast({
//             content: "Failed to save data",
//             type: "error",
//           });
//         });
//     }
//   };
  const items = [
    {
      label: "Small Cards",
      key: "smallcards",
      children: 
    //   (
    //     <DynamicForm
    //       config={AirlineServicesConfig}
    //       onSubmit={(data, buttonValue) =>
    //         onSubmit(
    //           data,
    //           `https://corporate-nprod-cms.myairports.com.my/api/page-content/102`,
    //           "UPDATE",
    //           "PATCH",
    //           buttonValue == "save" ? "DRAFT" : "PENDING"
    //         )
    //       }
    //     />
    //   ),
    (<SmallCards/>)
    },
    {
      label: "Large Cards",
      key: "largecards",
      children: (
        // <DynamicForm
        //   config={AirlineServicesConfig}
        //   onSubmit={(data, buttonValue) =>
        //     onSubmit(
        //       data,
        //       `https://corporate-nprod-cms.myairports.com.my/api/page-content/102`,
        //       "UPDATE",
        //       "PATCH",
        //       buttonValue == "save" ? "DRAFT" : "PENDING"
        //     )
        //   }
        // />
<LargeCards/>
      ),
    },
  
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
            navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};

export default SpotLight